export const USER_STATUS = {
  NORMAL: 'NORMAL',
  PENALTY_OUTSTANDING: 'PENALTY_OUTSTANDING',
  BANNED: 'BANNED',
};

export const getUserStatus = ({ user, hasOutstandingPenalties }) => {
  const isBanned = Boolean(user?.banned);
  const pendingPenaltyAmount = user?.sellerStats?.pendingPenaltyAmount ?? 0;
  const hasPendingFromProfile = pendingPenaltyAmount > 0;

  if (isBanned) {
    return USER_STATUS.BANNED;
  }
  if (hasOutstandingPenalties || hasPendingFromProfile) {
    return USER_STATUS.PENALTY_OUTSTANDING;
  }
  return USER_STATUS.NORMAL;
};

export const isUserBanned = (status) => status === USER_STATUS.BANNED;
export const hasOutstandingPenalty = (status) => status === USER_STATUS.PENALTY_OUTSTANDING;
